<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteProyecto"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mFeedAssetsContentModalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section
        v-if="showLoadingState"
        key="loadingState"
        class="m-the-modal-section"
      >
        <AtomLoadingSecondary/>
      </section>
      <section
        v-else
        key="modalSection"
        class="m-the-modal-section"
      >
        <p>
          {{ $t('mFeedAssetsContentModalDelete.messageDelete.element') }}
          <b>{{ element.titulo }}</b>
          {{ $t('mFeedAssetsContentModalDelete.messageDelete.options') }}
        </p>
        <small class="font-weight-bold text-color-danger">
            {{ $t('mFeedAssetsContentModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mFeedAssetsContentModalDelete.buttonCancel')"/>
        <AtomButtonPrimary
          v-if="Object.values(element).length"
          :button-primary="buttonPrimary"
        />
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeFeedAssetsContentModalDelete',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mFeedAssetsContentModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      },

      element: {},
      showLoadingState: true
    }
  },

  created () {
    if (this.$modal.element === null) {
      this.readProyecto()
    } else {
      this.element = Object.assign({}, this.$modal.element)
      this.showLoadingState = false
    }
  },

  methods: {
    deleteProyecto () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('proyecto', 'deleteProyecto', {}, [this.element.id])
          .then(response => {
            this.$modal.updateData('deleteElement')
            this.$license.readAcademiaRecursosUsados()
            this.$alerts.pushAlert('mFeedAssetsContentModalDelete', 'deleteProyecto', 'success')
            if (this.$route.name !== 'assets') {
              this.$router.push(`/${this.$t('rPaths.projects')}`)
            }
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            if (error.response.data.error.message === 'No se puede eliminar el proyecto. Hay inscripciones activas.') {
              this.$modal.closeModal()
              this.$modal.showModal('MoleculeFeedAssetsContentModalInscripcionActiva')
            } else if (error.response.data.error.message === 'El proyecto se encuentra activo en productos, no se puede eliminar.') {
              this.$modal.closeModal()
              this.$modal.showModal('MoleculeFeedAssetsContentModalProductoActivo')
            } else {
              this.$license.readAcademiaRecursosUsados()
              this.$alerts.pushAlert('mFeedAssetsContentModalDelete', 'deleteProyecto', 'error', 'a-alert-danger')
            }
            this.buttonPrimary.sending = false
          })
      }
    },

    readProyecto () {
      this.$services.read('proyecto', 'readProyecto', {}, [this.$route.params.id])
        .then(response => {
          this.element = response.data
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
